(function ($) {

	var initializeBlock = function ($block) {

		var carousel = $block.find('.gf-carousel'),
			prev = carousel.find('.gf-carousel__prev'),
			next = carousel.find('.gf-carousel__next'),
			curr = carousel.find('.gf-carousel__curr'),
			total = carousel.find('.gf-carousel__total'),
			$carousel = carousel.flickity({
				cellSelector: '.gf-carousel__item',
				cellAlign: 'left',
				prevNextButtons: false,
				pageDots: false,
				imagesLoaded: true
			}),
			flkty = $carousel.data('flickity');

		prev.on('click', function () {
			$carousel.flickity('previous');
		});

		next.on('click', function () {
			$carousel.flickity('next');
		});

		total.text(flkty.slides.length);

		function updateStatus() {
			curr.text(flkty.selectedIndex + 1);
		}
		updateStatus();
		$carousel.on('select.flickity', updateStatus);

		$carousel.on('cellSelect.flickity', function () {
			if (!flkty.cells[flkty.selectedIndex - 1]) {
				prev.attr('disabled', 'disabled');
				next.removeAttr('disabled');
			} else if (!flkty.cells[flkty.selectedIndex + 1]) {
				next.attr('disabled', 'disabled');
				prev.removeAttr('disabled');
			} else {
				prev.removeAttr('disabled');
				next.removeAttr('disabled');
			}
		});

	}

	// Initialize each block on page load (front end).
	$(document).ready(function () {
		$('.gf-block-carousel').each(function () {
			initializeBlock($(this));
		});
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction('render_block_preview/type=gf-carousel', initializeBlock);
	}

})(jQuery);